module.exports = __webpack_public_path__ + "media/this_is_me.57f2b41e.mp3";